import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const widgets = {
    namespaced: true,
    state: {
        tickerSettings: [],
    },
    getters: {
        getTickerSettingsList (state) {
            return state.tickerSettings;
        },
    },
    mutations: {
        setTickerSettingsList (state, settings) {
            state.tickerSettings = settings;
        },
    },
    actions: {
        async createTickerSettings ({ dispatch }, payload) {
            const url = '/ticker-settings';
            try {
                 await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating Ticker settings.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchTickerSettingsList ({ dispatch, commit }) {
            const url = '/ticker-settings';
            try {
                const settings = await axios.get(url);
                commit('setTickerSettingsList', settings.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the ticker settings list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
    },
};
